var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-delete"},[_c('button',{staticClass:"btn",class:{'no-editing-permission' : !_vm.editingPermission},attrs:{"type":"button","disabled":_vm.disabled}},[_c('IconDelete',{attrs:{"width":"25px","height":"25px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }